import './App.css';
import Router from './router';
import { BrowserRouter } from 'react-router-dom';
import { interCeptor } from './helper';
import { useSelector } from 'react-redux';
// import axios from 'axios';
// import { loginState } from './slices/loginSlice';
// import { REFRESH_TOKEN } from './constant/endpoint';
// import { useEffect, useRef } from 'react';

function App() {
  // const dispatch = useDispatch()
  // const inactivityTime = useRef(0);
  // const maxInactivityTime = 30 * 60 * 1000; // 30 minutes
  // const heartbeatInterval = 5 * 60 * 1000; // 5 minutes
  // const lastActivityKey = 'lastActivityTime';
  // const heartbeatKey = 'heartbeat';

  // const resetInactivityTime = () => {
  //     const currentTime = Date.now();
  //     localStorage.setItem(lastActivityKey, currentTime);
  //     inactivityTime.current = 0;
  // };

  // const logoutUser = () => {
  //     localStorage.clear()
  //     window.location.href = '/login';
  // };


  // const sendHeartbeat = async () => {
  //   const checkIfRefreshToken = await axios.get(REFRESH_TOKEN);
  //   if (checkIfRefreshToken?.data?.status === "success" ) {
  //    dispatch(loginState({ name: ['token'], value: checkIfRefreshToken.data.data }))
  //   }
  //   else {
  //     logoutUser()
  //   }
  // }


  // const checkInactivity = () => {
  //     const lastActivityTime = parseInt(localStorage.getItem(lastActivityKey), 10);
  //     if (Date.now() - lastActivityTime >= maxInactivityTime) {
  //         logoutUser();
  //     } else {
  //       // console.log(">>>>here");
  //         localStorage.setItem(heartbeatKey, Date.now());
  //         sendHeartbeat();
  //     }
  // };

  // useEffect(() => {
  //   const events = ['mousemove', 'keypress'];
  //   events.forEach(event => {
  //       window.addEventListener(event, resetInactivityTime);
  //   });

  //   const heartbeat = setInterval(checkInactivity, heartbeatInterval);

    // Handle heartbeat updates from other tabs
    // window.addEventListener('storage', (event) => {
    //   console.log('>>>>eve', event.key);
    //     if (event.key === heartbeatKey) {
    //         sendHeartbeat();
    //     }
    // });

//     return () => {
//         clearInterval(heartbeat);
//         events.forEach(event => {
//             window.removeEventListener(event, resetInactivityTime);
//         });
//     };
// }, []);
  const userInfo =  useSelector(state => state.loginSlice)
  interCeptor(userInfo.token)
  return (
    <div className="App">
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </div>
  );
}

export default App;
